import React, { useState } from 'react';
import {
  MAIN_FILTER_HEADING,
  AMENITIES_TYPE_FILTER,
  UNIT_SIZE_FILTER,
} from './constants/viewRatesFilterConfig';
import { Icon } from '../../../../../utilities/icomoon-css';
import {
  SectionContentTitle,
  Text,
} from '../../../../../components/textVariations';
import { UnitAvailabilityTypes } from '../UnitAvailabilityTypes';
import {
  handleSelectAllCheckbox,
  onFilterChange,
  addFilterToSavedFilterList,
} from './helpers/viewRatesFilterHelper';
import { SubFilterSection } from './helpers/ReusableFilterComponent';
import { Button } from '@codeparva/ui-components-library';

export const ViewRatesFilterModal = ({
  openResponsiveFilterHandler,
  amenitiesTypeFilterDivHeight,
  activeFilters,
  unitsFilter,
  unitsTypeFilterDivHeight,
  activeFilterStateHandler,
}: UnitAvailabilityTypes.TViewRatesFilterModal) => {
  const [smallScreenActiveFilter, setSmallScreenActiveFilter] = useState(
    activeFilters
  );
  const [savedActiveFilter, setSavedActiveFilter] = useState<any>([]);
  const [smallScreenFilterStatus, setSmallScreenFilterStatus] = useState({
    showUnitTypeFilter: false,
    showAmenitiesTypeFilter: false,
  });

  const addFilterToActiveFilter = (
    indivUnitType: UnitAvailabilityTypes.TFilterObject
  ) => {
    if (indivUnitType.name === 'All') {
      handleSelectAllCheckbox(
        indivUnitType,
        smallScreenActiveFilter,
        setSmallScreenActiveFilter,
        unitsFilter
      );
    } else {
      onFilterChange(
        indivUnitType,
        smallScreenActiveFilter,
        setSmallScreenActiveFilter,
        activeFilters
      );
    }
  };

  const smallScreenFilterHandler = (
    indivUnitType: UnitAvailabilityTypes.TFilterObject
  ) => {
    addFilterToActiveFilter(indivUnitType);
    addFilterToSavedFilterList(
      indivUnitType,
      savedActiveFilter,
      setSavedActiveFilter
    );
  };

  const clearFilter = () => {
    onFilterChange(
      { type: 'clearAll', name: 'clearAll', value: 'clearAll' },
      activeFilters,
      activeFilterStateHandler,
      unitsFilter
    );
    openResponsiveFilterHandler();
  };

  const finalApplyFilter = () => {
    savedActiveFilter.map((indivFilter: any) =>
      onFilterChange(
        indivFilter,
        activeFilters,
        activeFilterStateHandler,
        unitsFilter
      )
    );
    openResponsiveFilterHandler();
  };

  const changeFilterDropDownStatus = (filterType: string) => {
    if (filterType === 'amenities') {
      setSmallScreenFilterStatus(prevState => ({
        ...prevState,
        showAmenitiesTypeFilter: !prevState.showAmenitiesTypeFilter,
      }));
      setSavedActiveFilter([]);
      setSmallScreenActiveFilter(activeFilters);
    } else {
      setSmallScreenFilterStatus(prevState => ({
        ...prevState,
        showUnitTypeFilter: !prevState.showUnitTypeFilter,
      }));
      setSavedActiveFilter([]);
      setSmallScreenActiveFilter(activeFilters);
    }
  };

  const ModelFooter = () => {
    return (
      <div className="footerParent">
        <div className="modalFooter">
          <Button className="is-outlined" onClick={openResponsiveFilterHandler}>
            Close
          </Button>
          <hr />
          <Button
            className="is-outlined highlighted"
            disabled={
              smallScreenActiveFilter.length != activeFilters.length
                ? false
                : true
            }
            onClick={finalApplyFilter}
          >
            Apply
          </Button>
        </div>
      </div>
    );
  };

  return (
    <div className="modal viewRatesFilterModalSection">
      <div className="modal-card">
        <section className="modal-card-body">
          <div className="modalHeader">
            <div className="nameSection" onClick={clearFilter}>
              <Icon name="tfw-filter-2-cp" />
              <SectionContentTitle>{MAIN_FILTER_HEADING}</SectionContentTitle>
            </div>
            <div className="closeIconSection" onClick={clearFilter}>
              <Text renderAs={'p'}>Clear All</Text>
            </div>
          </div>
          <div className="modalFilterSection">
            <SubFilterSection
              filterType={'amenities'}
              currStatus={smallScreenFilterStatus.showAmenitiesTypeFilter}
              heightFromTop={amenitiesTypeFilterDivHeight}
              sectionText={'Amenities'}
              typeFilter={AMENITIES_TYPE_FILTER}
              changeFilterDropDownStatus={changeFilterDropDownStatus}
              smallScreenActiveFilter={smallScreenActiveFilter}
              smallScreenFilterHandler={smallScreenFilterHandler}
              unitsFilter={unitsFilter}
            />
            <SubFilterSection
              filterType={'unitsType'}
              currStatus={smallScreenFilterStatus.showUnitTypeFilter}
              heightFromTop={unitsTypeFilterDivHeight}
              sectionText={'Unit Size'}
              typeFilter={UNIT_SIZE_FILTER}
              changeFilterDropDownStatus={changeFilterDropDownStatus}
              smallScreenActiveFilter={smallScreenActiveFilter}
              smallScreenFilterHandler={smallScreenFilterHandler}
              unitsFilter={unitsFilter}
            />
          </div>
        </section>
        <ModelFooter />
      </div>
    </div>
  );
};
